<template>
  <div class="subjectAdmin">
    <el-card>
      <el-form :model="searchForm" inline label-width="100px" size="small" ref="form">
        <el-form-item label="题目" prop="title">
          <el-input v-model="searchForm.title" placeholder="请输入题目" />
        </el-form-item>
        <el-form-item label="题型" prop="type">
          <el-select v-model="searchForm.type">
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in subjectType" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间" prop="date1">
          <my-datePicker :scopeDate="searchForm.date1" @receiveMyDate="receiveMyDate" />
        </el-form-item>
        <!-- <el-form-item label="所属项目" prop="projectId">
          <el-select v-model="searchForm.projectId" style="width:100%">
            <el-option :label="item.projectName" :value="item.id" v-for="(item,index) in projectData" :key="index"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item style="margin-left: 50px">
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset('form')" style="margin-left: 8px">重置</el-button>
        </el-form-item>
        <el-form-item style="margin-left: 50px">
          <!-- <el-button type="primary" @click="export_action('daochu')">导出题目</el-button> -->
          <el-button style="margin-left: 8px" @click="export_action('down')">下载模板</el-button>
          <el-upload class="upload-demo" accept=".xlsx" :action="uploadbaseURL" :on-success="uploadSuccess" :before-upload="uploadBefore" :on-error="uploadError" :headers="uploadHeader">
            <el-button size="small" type="primary" :loading="exportLocalLoading">导入题目</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-row>
        <el-col>
          <el-button type="primary" @click="action('add')">添加题目</el-button>
        </el-col>
      </el-row>
    </el-card>
    <br />
    <subjectTable ref="subjectTable" :tableData="tableData" :loading="loading" @update="update" />
    <br />
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <!-- 添加编辑题目 -->
    <subjectAdd ref="subjectAdd" @update="update" />
  </div>
</template>

<script>
import myDatePicker from "@/components/myDatePicker.vue";
import { subjectType } from "../dict"
import tableMoudel from "@/libs/mixins/table"
import { projectMoudel } from "../mixins"
import { examTopicPage } from "../api"
import subjectAdd from "./com/add.vue"
import subjectTable from "./com/table.vue"
import { downloadData } from '@/api/common'
import Cookies from 'js-cookie'

import excel from '@/libs/excel'
import { baseURL } from '@/api/request'


export default {
  components: { myDatePicker, subjectAdd, subjectTable },
  mixins: [tableMoudel, projectMoudel],
  data () {
    return {
      uploadbaseURL: `${baseURL}/exam/adm/examPaperTopic/importExamPaperTopic`,
      uploadHeader: {},
      subjectType,
      searchForm: {
        title: null,
        type: null,
        date1: null,
        date2: null,
        projectId: null,
      },
      exportLocalLoading: false,
      tableLocalData: []
    }
  },
  created () {
    this.getData('init')
    const token = Cookies.get('tvToken') || Cookies.get('token')
    if (token) {
      this.uploadHeader = {
        Authorization: 'Bearer ' + token
      }
    }
  },
  methods: {
    action (key, item) {
      switch (key) {
        case 'add':
          this.$refs.subjectAdd.init()
          break;
      }
    },
    toggleOpen (item) {
      item.show = !item.show
    },
    update () {
      this.getData('init')
    },
    async getData (type) {
      if (type == 'init') {
        this.searchForm.date1 = null
        this.searchForm.date2 = null
      }
      const params = { ...this.pageInfo, ...this.searchForm }
      const payload = params.date1
      if (payload && payload.length > 0) {
        params.date1 = payload[0] + " 00:00:00";
        params.date2 = payload[1] + " 23:59:59";
      }
      const res = await examTopicPage(params)
      const { records, total } = res.data
      this.total = Number(total)
      this.tableData = records
    },
    receiveMyDate (payload) {
      this.searchForm.date1 = payload
      // this.searchForm.date1 = payload[0] + " 00:00:00";
      // this.searchForm.date2 = payload[1] + " 23:59:59";
    },
    exportLocalExcel () {
      if (this.tableLocalData.length > 0) {
        const params = {
          title: ['试卷名称', '题目', '所属项目', '题型', '选项A', '选项B', '选项c', '选项D', '选项E', '材料', '答案', '解析', '分值', '排序号', '备注'],
          key: ['title', 'knowledgeMsg', 'subjectName', 'typeName', 'optionDescribe1', 'optionDescribe2', 'optionDescribe3', 'optionDescribe4', 'optionDescribe5', 'material', 'answer', 'parsing', 'scoreExamTopic', 'sortNum', 'remark'],
          data: this.tableLocalData,
          autoWidth: true,
          filename: '导入报告' + Date.parse(new Date())
        }
        excel.export_array_to_excel(params)
        this.$message.info('导入结束，请查看导入报告！')
      } else {
        this.$message.info('导入报告为空！')
      }
    },
    uploadSuccess (response, file, fileList) {
      this.tableLocalData = response.data
      this.exportLocalExcel()
      this.exportLocalLoading = false
      this.getData('init')
    },
    uploadBefore (file) {
      const fileExt = file.name.split('.').pop().toLocaleLowerCase()
      if (fileExt === 'xlsx') {
        if (this.exportLocalLoading == false) {
          this.exportLocalLoading = true
          return true
        } else {
          this.$message.error('正在导入中请不要进行操作！')
        }
      } else {
        this.$message.error('文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx的EXCEL文件。')
      }
      return false
    },
    uploadError (error, file, fileList) {
      this.$message.error('网络异常，请联系管理员。')
      this.exportLocalLoading = false
    },
    async export_action (key) {
      switch (key) {
        case 'daochu':
          console.log('导出')
          downloadData(
            `/exam/adm/examPaperTopic/exportExamPaperTopic`,
            {examPaperId: this.examPaperId}
          )
          break;
        case 'down':
          downloadData(
            `/exam/adm/examPaperTopic/exportExamPaperTopic`,
            {examPaperId: 0}
          )
          break;
        case 'daoru':
          console.log('导入')
          break;

        default:
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title_top {
  display: flex;
  i {
    cursor: pointer;
  }
  .open {
    margin-right: 8px;
  }
}

.item_cont {
  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 12px;
  }
}
.item {
  text-align: left;
  .left {
    flex: 1;
    display: inline-flex;
    flex-wrap: wrap;
  }
  .right {
    width: 160px;
    display: inline-flex;
    flex-wrap: wrap;
  }
  .label {
    margin-right: 6px;
  }
}
.upload-demo {
  display: inline-block;
  vertical-align: middle;
  margin-left: 8px;
}
::v-deep .el-upload-list {
  display: inline-block;
  vertical-align: middle;
  margin: 0 12px;
  .el-upload-list__item:first-child {
    margin: 0;
  }
}
</style>
